import type { RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList'
import { useRefinementList } from 'react-instantsearch'

function transformItems(items: RefinementListItem[]) {
  // oxlint-disable-next-line unicorn/no-array-sort
  return items.sort((a, b) => a.value.localeCompare(b.value))
}

export function useTagsList() {
  const { items, refine } = useRefinementList({
    attribute: 'tags',
    limit: 20,
    transformItems,
  })

  const onValueChange = (value: string) => {
    refine(value)
  }

  return {
    data: items,
    onValueChange,
  }
}

export function useFilterList(attribute: string) {
  const { items, refine } = useRefinementList({
    attribute,
    transformItems,
  })

  const onValueChange = (option: string) => {
    refine(option)
  }

  return {
    items,
    onValueChange,
  }
}
